export const CAMPAIGN_STATUS_TAGS = {
	active: { label: 'Aktiv', tone: 'success' },
	paused: { label: 'Pausiert', tone: 'caution' },
	completed: { label: 'Abgeschlossen', tone: 'neutral' },
	draft: { label: 'Entwurf', tone: 'neutral' },
};

export const getCampaignStatusTag = (status) => ({
	prefix: 'Status',
	...(CAMPAIGN_STATUS_TAGS[status] ?? CAMPAIGN_STATUS_TAGS.draft),
});
